import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "link", "hasUnderline", "twStyle", "newTab", "onLinkClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigationContext } from '@restworld/utils-common';
import { V2Link } from '../../feature-components';
import { jsx as _jsx } from "react/jsx-runtime";
export var LinkBase = function LinkBase(_ref) {
  var children = _ref.children,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? '#!' : _ref$link,
      hasUnderline = _ref.hasUnderline,
      twStyle = _ref.twStyle,
      _ref$newTab = _ref.newTab,
      newTab = _ref$newTab === void 0 ? true : _ref$newTab,
      onLinkClick = _ref.onLinkClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useNavigationContext = useNavigationContext(),
      linkComponent = _useNavigationContext.linkComponent;

  return /*#__PURE__*/_jsx(_StyledLinkStyled, _objectSpread(_objectSpread({
    onClick: function onClick(e) {
      if (onLinkClick) onLinkClick(e);
      e.stopPropagation();
    },
    as: !!link && !!linkComponent ? linkComponent : undefined,
    href: link,
    target: newTab ? '_blank' : undefined,
    rel: newTab ? 'noopener noreferrer' : undefined,
    $hasUnderline: hasUnderline,
    $twStyle: twStyle
  }, rest), {}, {
    children: children
  }));
};
export default LinkBase;

var LinkStyled = /*#__PURE__*/_styled(V2Link).withConfig({
  displayName: "link-base__LinkStyled",
  componentId: "sc-l73i32-0"
})(function (_ref2) {
  var $hasUnderline = _ref2.$hasUnderline,
      $twStyle = _ref2.$twStyle;
  return [{
    "cursor": "pointer",
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))"
  }, $hasUnderline && {
    ":hover": {
      "textDecorationLine": "underline",
      "textUnderlineOffset": "4px"
    }
  }].concat(_toConsumableArray($twStyle && Array.isArray($twStyle) ? $twStyle : []), [$twStyle && !Array.isArray($twStyle) ? $twStyle : {}]);
});

var _StyledLinkStyled = /*#__PURE__*/_styled(LinkStyled).withConfig({
  displayName: "link-base___StyledLinkStyled",
  componentId: "sc-l73i32-1"
})({
  "cursor": "pointer"
});